let HOST = "https://api.useo2o.com"

// Check GATSBY_API_BASE first (set at build time, available in browser).
const apiBase = process.env.GATSBY_API_BASE || ""

// For local development and CI with proxy: use empty string (relative URLs go through Gatsby proxy).
const isLocalProxy = apiBase && (
  apiBase.includes("127.0.0.1") ||
  apiBase.includes("localhost:") ||
  apiBase.includes(".ddev.site") ||
  process.env.GATSBY_FORCE_PROXY === "true"
)

if (isLocalProxy) {
  // Use relative URLs - requests will be proxied by Gatsby dev server.
  HOST = ""
} else if (apiBase) {
  HOST = apiBase
} else if (
  typeof window !== "undefined" &&
  (window.location.hostname === "test.app.useo2o.com" ||
    window.location.hostname.includes("app-o2otest.netlify.app"))
) {
  HOST = "https://test.api.useo2o.com"
} else if (
  typeof window !== "undefined" &&
  (window.location.hostname === "dev.app.useo2o.com" ||
    window.location.hostname.includes("app-o2odev.netlify.app") ||
    window.location.hostname.includes("localhost"))
) {
  HOST = "https://dev.api.useo2o.com"
}

export const verifiedHost = HOST

export const isDev = HOST !== "https://api.useo2o.com"
